import { MutationOptions, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import { graphql } from '@/gql';
import {
  UpdateProposalLineItemInput,
  UpdateProposalLineItemMutation,
} from '@/gql/graphql';

const UPDATE_PROPOSAL_LINE_ITEM_MUTATION = graphql(`
  mutation UpdateProposalLineItem($input: UpdateProposalLineItemInput!) {
    updateProposalLineItem(input: $input) {
      ...ProposalLineItem
    }
  }
`);

/**
 * Unlike `useMutation`, the caller does not subscribe to the mutation's state,
 * so a save starting and settling does not re-render the component that fires
 * it. Read pending saves with `useIsMutating` where they are shown.
 */
const useUpdateProposalLineItem = (args?: {
  proposalId?: string;
  options?: MutationOptions<
    UpdateProposalLineItemMutation,
    unknown,
    UpdateProposalLineItemInput
  >;
}) => {
  const queryClient = useQueryClient();

  const mutateAsync = (input: UpdateProposalLineItemInput) =>
    queryClient
      .getMutationCache()
      .build(queryClient, {
        mutationFn: (variables: UpdateProposalLineItemInput) => {
          return gqlClient.request(UPDATE_PROPOSAL_LINE_ITEM_MUTATION, {
            input: variables,
          });
        },
        scope: args?.proposalId
          ? { id: proposalMutationScopeId(args.proposalId) }
          : undefined,
        ...args?.options,
      })
      .execute(input);

  return { mutateAsync };
};

export default useUpdateProposalLineItem;
